import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Kişisel Verilerin Korunması ve Gizlilik Politikası
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold mb-4">1. VERİ SORUMLUSU</h2>
            <p className="mb-4">
              Bu Kişisel Verilerin Korunması ve Gizlilik Politikası ("Politika"), 
              Fiel Home (MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA) 
              tarafından yürütülen faaliyetler kapsamında toplanan kişisel verilerin 
              işlenmesine ilişkin uygulanan ilke ve kuralları açıklamaktadır.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">2. KİŞİSEL VERİLERİN TOPLANMA YÖNTEMİ VE HUKUKİ SEBEBİ</h2>
            <p className="mb-4">
              Kişisel verileriniz; www.fielhome.com internet sitesi, mobil uygulamalar, 
              sosyal medya platformları, çağrı merkezi ve şubelerimiz aracılığıyla 
              sözlü, yazılı veya elektronik yöntemlerle toplanmaktadır.
            </p>
            
            <h3 className="text-lg font-semibold mb-3">2.1. Toplanan Kişisel Veriler</h3>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kimlik Bilgileri (ad, soyad, T.C. kimlik numarası)</li>
              <li>İletişim Bilgileri (telefon, e-posta, adres)</li>
              <li>Müşteri İşlem Bilgileri (sipariş geçmişi, ödeme bilgileri)</li>
              <li>Pazarlama Bilgileri (tercihler, beğeniler)</li>
              <li>Çerez ve İnternet Sitesi/Mobil Uygulama Log Bilgileri</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">3. KİŞİSEL VERİLERİN İŞLENME AMAÇLARI</h2>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Satış sözleşmesinin kurulması ve ifası</li>
              <li>Ürün ve hizmet satış süreçlerinin yürütülmesi</li>
              <li>Müşteri hizmetlerinin sunulması</li>
              <li>Pazarlama faaliyetlerinin yürütülmesi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>İstatistik ve analiz çalışmaları</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">4. VERİLERİN AKTARILMASI</h2>
            <p className="mb-4">
              Toplanan kişisel verileriniz; hizmet aldığımız üçüncü kişiler, 
              yasal yükümlülüklerimizi yerine getirmek amacıyla kamu kurum ve 
              kuruluşları ile paylaşılabilir.
            </p>
            
            <h2 className="text-xl font-semibold mb-4">5. HAKLARINIZ</h2>
            <p className="mb-4">
              6698 sayılı Kanun'un 11. maddesi uyarınca sahip olduğunuz haklar:
            </p>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz hakkında bilgi talep etme</li>
              <li>Kişisel verilerinizin işlenme amacını öğrenme</li>
              <li>Kişisel verilerinizin düzeltilmesini talep etme</li>
              <li>Kişisel verilerinizin silinmesini talep etme</li>
              <li>Kişisel verilerinizin işlenmesine itiraz etme</li>
            </ul>
            
            <h2 className="text-xl font-semibold mb-4">6. İLETİŞİM</h2>
            <p className="mb-4">
              Kişisel verileriniz ile ilgili sorularınız için:
            </p>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p><strong>Adres:</strong> MAHMUDİYE MAH. ERTUĞRUL GAZİ CAD. NO: 46 A İNEGÖL/BURSA</p>
              <p><strong>Telefon:</strong> +90 552 229 90 07</p>
              <p><strong>E-posta:</strong> info@fielhome.com</p>
            </div>
            
            <p className="mt-8 text-sm text-gray-600">
              Bu politika {new Date().toLocaleDateString('tr-TR')} tarihinde güncellenmiştir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
